var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-left q-mt-sm q-mb-md label medium light"},[_c('span',[_vm._v(_vm._s(_vm.dataTitle))])]),_c('div',[_c('highcharts',{staticClass:"chart",attrs:{"options":_vm.chartOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }